import { Routes, Route } from 'react-router-dom';
import { ReactElement, Suspense, lazy } from 'react';

type RouteItem = {
    path: string;
    component: ReactElement<any, any>;
};

const TrackingPage = lazy(() => import('../pages/TrackingPage'));
const RatingPage = lazy(() => import('../pages/RatingPage'));

const ROUTES_ARRAY: RouteItem[] = [
    {
        path: '/',
        component: <TrackingPage />,
    },
    {
        path: '/:id',
        component: <TrackingPage />,
    },
    {
        path: '/rating/:idTracking',
        component: <RatingPage />,
    },
];
export const AppRoutes = () => (
    <Suspense>
        <Routes>
            {ROUTES_ARRAY.map((route) => (
                <Route key={route.path} path={route.path} element={route.component} />
            ))}
        </Routes>
    </Suspense>
);

export default AppRoutes;
